import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "David Miller",
      role: "CEO at FintechFlow",
      text: "Amavix Tech transformed our legacy system into a high-speed SaaS platform. Their engineering precision is unmatched.",
      rating: 5
    },
    {
      name: "Sophia Rodriguez",
      role: "Founder of GreenLogix",
      text: "The AI route optimization they built for us reduced our waste by 20%. Professional, responsive, and technically brilliant.",
      rating: 5
    },
    {
      name: "James Wilson",
      role: "CTO at Streamline ERP",
      text: "Working with Amavix felt like having an elite in-house team. They understood our complex requirements from day one.",
      rating: 5
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">What Our <span>Clients</span> Say</h2>
          <p className="section-subtitle">Trusted by forward-thinking companies worldwide.</p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <motion.div 
              key={i} 
              className="testimonial-card"
              whileInView={{ y: 0, opacity: 1 }}
              initial={{ y: 20, opacity: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="t-stars">
                {[...Array(t.rating)].map((_, idx) => <Star key={idx} size={14} fill="var(--accent-primary)" color="var(--accent-primary)" />)}
              </div>
              <Quote className="t-quote-icon" />
              <p className="t-text">"{t.text}"</p>
              <div className="t-footer">
                <strong>{t.name}</strong>
                <span>{t.role}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
